import { AxiosError } from 'axios';
import i18n from 'config/i18n';
import i18next from 'i18next';
import { path } from 'ramda';

import { getLocale } from 'utils/date';

import { showErrorSnackbar } from './Snackbar';

const t = i18n.getFixedT(getLocale(), 'common');

export const getTranslationKeyIfExists = (
  translationKey: string
): string | null => {
  if (translationKey && i18next.exists(translationKey)) {
    return translationKey;
  } else {
    return null;
  }
};

const showError = (error: AxiosError) => {
  const translationKey = path(
    ['response', 'data', 'error', 'message'],
    error
  ) as string | undefined;
  if (translationKey && getTranslationKeyIfExists(translationKey)) {
    showErrorSnackbar(t(translationKey));
  } else {
    showErrorSnackbar();
  }
};

export default showError;
